export const GenderToIndex = Object.freeze({
  female: 2,
  male: 1,
  neutral: 0,
  else: 0,
  na: 0,
});
